

import React, { useState,useEffect } from 'react'
import styled from 'styled-components'
import { LargeButton, LoaderDots, MaterialInput, OverlayLoader, Icons, PageTitle } from '../components/core'
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {  useNavigate, useParams } from "react-router-dom";
import http from "../services/httpService";
import useTopScroll from '../hooks/useTopScroll';
import SideNav from '../components/sideNav';
import SideNavContent from '../components/sideNavContent';
import routes from '../components/routes';
import { BaseDropdown } from 'components/core';
import { capitalize } from 'lodash';


const CompanyInfo =()=>  {
  const [loading,setLoading] = useState(true)
  const [submitLoader, setSubmitLoader] = useState(false)
  const [is_click,setIsClick] = useState(false)
  const [apidata,setApiData] = useState([])
  const [initialValues, setInitialValues] = useState({})
  const [warnings, setWarnings] = useState([])
  const [industries, setIndustries] = useState([])
  const [employeeRange, setEmployeeRange] = useState([])
  const [flexPointUse, setFlexPointUse] = useState([])
  const [employeeCollectionRequired, setEmployeeCollectionRequired] = useState('NO')
  // const [IFA, setIFA] = useState([])
  const {type} = useParams()

  const flow = localStorage.getItem('flow')
  const showSidebar = () => {
    return !!localStorage.getItem('id') && (type !== "onboarding")
  }

  const planEditableLS = JSON.parse(localStorage.getItem('isPlanEditable')) || 'false'
  const editableField = ((type === "edit") && planEditableLS) ? true : false

  useTopScroll()
  const getData =  async () => {
    const userplan_id = localStorage.getItem('userplan_id') || sessionStorage.getItem('userplan_id') || ''
    if (userplan_id) {
      try{
        const {data} = await http.get(`/business/get_company_profile/`,{
          params: {
            userplan_id: localStorage.getItem('userplan_id')
          }
        })
        const profile = data.data
        const hasPrimaryContact = Array.isArray(profile?.primary_contact) && profile.primary_contact.length > 0
        const primaryContact = hasPrimaryContact ? profile.primary_contact[0] : {}
        const backendInitValues = {
          company_name: profile['company_name'] || '',
          industry: profile['industry'] || '',
          range_of_employees: profile['range_of_employees'] || '',
          city: profile['address'] || '',
          pincode: profile['pincode'] || '',
          // gstno: profile['gst_no'] ||  '',
          primary_contact_name: hasPrimaryContact ? (primaryContact?.name || '') : (profile['primary_contact_name'] || ''),
          primary_contact_mobile: hasPrimaryContact ? (primaryContact?.phone_no || '') : (profile['phone'] || ''),
          primary_contact_email: hasPrimaryContact ? (primaryContact?.email || '') : (profile['email'] || ''),
          secondary_contact_name: profile['secondary_contact_name'] ||  '',
          secondary_contact_mobile: profile['secondary_contact'] ||  '',
          secondary_contact_email: profile['secondary_email'] ||  '',
          source: profile['source'] ||  '',
          employee_collection_required: profile['employee_collection_required'] || false,
          flex: profile['flex'] || ''
        }
        setInitialValues(backendInitValues)
      } catch(ex){
        console.log({ex})
      }    
    } else {
      setInitialValues({
        flex: localStorage.getItem('flex') || '',
        employee_collection_required: localStorage.getItem('employee_collection_required') || false,
        source: localStorage.getItem('source') || "" ,
        company_name: localStorage.getItem('company_name') || "" ,
        industry: localStorage.getItem('industry') || "" ,
        range_of_employees: localStorage.getItem('range_of_employees') || "" ,
        city: localStorage.getItem('city') || "",
        pincode:  localStorage.getItem('pincode') || "",
        gstno: localStorage.getItem('gstno') || "",
        primary_contact_name: localStorage.getItem('primary_contact_name') || "",
        primary_contact_mobile: localStorage.getItem('primary_contact_mobile') || "",
        primary_contact_email: localStorage.getItem('primary_contact_email') || "",
        secondary_contact_name: localStorage.getItem('secondary_contact_name') || "",
        secondary_contact_mobile: localStorage.getItem('secondary_contact_mobile') || "",
        secondary_contact_email: localStorage.getItem('secondary_contact_email') || "",
      })
    }
    setLoading(false)  
  }

  // const getIFAs = async () => {
  //   try{
  //     const {data} = await http.get("/ifa/list_of_ifas/")
  //     setIFA(data['message'] && data['message']['ifas'])
  //   } catch(ex){
  //     setIFA([])
  //   }
    
  // }
  const getCompanyDetails = async() => {
    try{
      const {data} = await http.get("business/get_company_setup_details/")
      setIndustries(data.industry_type)
      setEmployeeRange(data.range_of_employees)
      setFlexPointUse(data?.flex_points_usage_type)
    } catch(e){
      console.log(e)
    }
  }

  useEffect(() => {
    getData()
    getCompanyDetails()
    localStorage.removeItem("flex_userplan_ids")
    // getIFAs()
  },[])

  const userplan_id = localStorage.getItem('userplan_id') || sessionStorage.getItem('userplan_id') || ''
  let navigate =  useNavigate();

  const handleChange = (event, setFieldValue, name, length) => {
    const value = event.target.value;
    setFieldValue(name, value.slice(0, length));
  };

  const renderInput = ({
    name,
    placeholder,
    type,
    formikProps,
    length = 100,
    nonEditableField
  } = {}) => {
    const { errors, touched, handleBlur, setFieldValue, values } = formikProps;
    const error = touched[name] && errors[name];
    return (
      <InputContainer>
        <MaterialInput
          value={values[name]}
          name={name}
          placeholder={placeholder}
          type={type}
          error={error}
          onChange={(event) =>
            handleChange(event, setFieldValue, name, length)
          }
          onBlur={handleBlur}
          disabled={!!nonEditableField}
          Readonly = {!!nonEditableField}
        />
      </InputContainer>
    );
  };

  const renderInputEditable = ({
    name,
    placeholder,
    type,
    formikProps,
    length = 70,
    nonEditableField
  } = {}) => {
    const { errors, touched, handleBlur, setFieldValue, values } = formikProps;
    const error = touched[name] && errors[name];
    return (
      <InputContainer>
        <MaterialInput
          value={values[name]}
          name={name}
          placeholder={placeholder}
          type={type}
          error={error}
          onChange={(event) =>
            handleChange(event, setFieldValue, name, length)
          }
          onBlur={handleBlur}
          img={!!nonEditableField}
          // Readonly = {!editable}
        />
      </InputContainer>
    );
  };

  const renderInputNonEditable = ({
    name,
    placeholder,
    type,
    formikProps,
    length = 70,
    nonEditableField
  } = {}) => {
    const { errors, touched, handleBlur, setFieldValue, values } = formikProps;
    const error = touched[name] && errors[name];
    return (
      <InputContainer>
        <MaterialInput
          value={values[name]}
          name={name}
          placeholder={placeholder}
          type={type}
          error={error}
          onChange={(event) =>
            handleChange(event, setFieldValue, name, length)
          }
          onBlur={handleBlur}
          disabled={!!nonEditableField}
          Readonly = {!!nonEditableField}
        />
      </InputContainer>
    );
  };

  const redirectToNextPage = (values) => {
    // if(userplan_id) {
    //   navigate(`/${routes.CARE_DASHBOARD}`)
    // } else if(flow === 'GMC' && employeeCollectionRequired === 'YES'){
    //   navigate(`/${routes.THANKYOU_PAGE}`);
    // } else if(flow === 'GMC' && employeeCollectionRequired === 'NO') {
    //   navigate(`/${routes.INSURANCE_SETUP}`)
    // } else {
    //   navigate(`/${routes.BUILD_PLAN}/onboarding`)
    // }
    if(userplan_id) {
      navigate(`/${routes.CARE_DASHBOARD}`)
    } else{
      navigate(`/${routes.PLAN_SELECTION}`)
    }
    // else if(values.flex === 'YES'){
    //   navigate(`/${routes.FLEX_BENEFITS_SETUP}`)
    // } else if((values.flex === 'NO') && values.employee_collection_required == 'NO') {
    //   navigate(`/${routes.INSURANCE_SETUP}`)
    // } else if((values.flex === 'NO') && values.employee_collection_required == 'YES') {
    //   navigate(`/${routes.THANKYOU_PAGE}`)
    // }
  }

  const handleSubmit = async (values) => {
    localStorage.removeItem("super_task_id");
    if(is_click==true){
      return
    }
    let employeeColleciton = false
    let edit_dependent_details_allowed = false
    let flex = false
    if(values.employee_collection_required === 'YES'){
      employeeColleciton = false
    } else {
      employeeColleciton = true
    }
    
    if(values.edit_dependent_details_allowed === 'YES'){
      edit_dependent_details_allowed = true
    } else if(values.edit_dependent_details_allowed === 'NO'){
      edit_dependent_details_allowed = false
    }

    if(values.flex === 'YES'){
      flex = true
      employeeColleciton = false
    } else{
      flex = false
    }
    setIsClick(true)
    setSubmitLoader(true)
    const empDataCollection = values.employee_collection_required
    setEmployeeCollectionRequired(empDataCollection)
    const business_id = localStorage.getItem('id');
    if(userplan_id || business_id){ //EDIT PLAN
      try{
        const {data} = await http.post("/business/edit_company/",{
          business_user_id: business_id,
          phone_no:values.primary_contact_mobile,
          is_business:true,
          email: values.primary_contact_email,
          company:{
            company_name:values['company_name'],
            industry:values['industry'],
            range_of_employees: values['range_of_employees'],
            pincode:values['pincode'],
            source:"",
            primary_contact_name:values.primary_contact_name,
            secondary_contact_name:values.secondary_contact_name,
            secondary_contact:values.secondary_contact_mobile,
            secondary_email:values.secondary_contact_email
          },
          address:{
            type:"Current Address",
            city:values.city,
            pincode:values.pincode
          }
        });
        const {data: backendData} = data
        localStorage.setItem('token', backendData.token)
        localStorage.setItem('id', backendData?.id)
        if(backendData?.company?.userplan_id) {
          localStorage.setItem('userplan_id', backendData?.company?.userplan_id)
        }
        localStorage.setItem('phone', backendData?.phone_no)
        redirectToNextPage(values)
        return
      } catch (ex){
        console.log(ex.response.data.message)
        alert(ex.response.data.message)
      }
      
    } else { //CREATE PLAN
      localStorage.setItem('flex', values.flex)
      localStorage.setItem('employee_collection_required', values.employee_collection_required)
      localStorage.setItem('company_name',values.company_name)
      localStorage.setItem('industry',values.industry)
      localStorage.setItem('range_of_employees',values.range_of_employees)
      localStorage.setItem('city',values.city)
      localStorage.setItem('pincode',values.pincode)
      // localStorage.setItem('gstno',values.gstno)
      localStorage.setItem('primary_contact_name',values.primary_contact_name)
      localStorage.setItem('primary_contact_email',values.primary_contact_email)
      localStorage.setItem('primary_contact_mobile',values.primary_contact_mobile)
      localStorage.setItem('phone',values.primary_contact_mobile)
      localStorage.setItem('secondary_contact_name',values.secondary_contact_name)
      localStorage.setItem('secondary_contact_email',values.secondary_contact_email)
      localStorage.setItem('secondary_contact_mobile',values.secondary_contact_mobile)
      if(flow !== 'GMC'){
        values.employee_collection_required = false
      }
      try {
        const data  = await http.post("/users/user/",{
          phone_no:values.primary_contact_mobile,
          is_business:true,
          email: values.primary_contact_email,
          company:{
            source:values.source,
            employee_collection_required:values.employee_collection_required,
            company_name:values['company_name'],
            industry:values['industry'],
            range_of_employees: values['range_of_employees'],
            pincode:values['pincode'],
            // gst_no:values.gstno,
            primary_contact_name:values.primary_contact_name,
            secondary_contact_name:values.secondary_contact_name,
            secondary_contact:values.secondary_contact_mobile,
            secondary_email:values.secondary_contact_email,
            are_flex_total_points: values.are_flex_total_points,
            flex:flex
          },
          address:{
            type:"Current Address",
            city:values.city,
            pincode:values.pincode
          }
        });
        localStorage.setItem('id',data.data.id)
        if(flow == 'GMC'){
          localStorage.setItem('gmc_company_id', data.data.company.id)
        }
        const profile_data = await http.get("/phone/get_token/",
            {params:{
              user_id:data.data.id
            }
          })
        localStorage.setItem('token',profile_data.data.token)
        let warnings = data.data['warnings']
        let FormattedWarnings = warnings.map( item => Object.values(item))
        setApiData(apidata)
        redirectToNextPage(values)
        // if(FormattedWarnings.length){
        //   setWarnings(FormattedWarnings)
        // } else {
        //   redirectToNextPage(values)
        // }
      } catch (e) {
        if(e.response.data.pincode)
        {
          alert(e.response.data.pincode[0])
        }
        else if(e.response.data.company)
        {
          alert(e.response.data.company['gst_no'])
        }
        else{
          alert(e.response.data.phone[0])
        }
        setSubmitLoader(false)
        // this.setState({ loading: false });
      }
    // this.setState({})

    }
    
    setSubmitLoader(false)
    setIsClick(false)
  };

  const getFontLabelFontSize = (value) => {
    if(value || value === false) return 19
    return 14
  }

  const renderFlexDropdown = ({formikProps, name}) => {
    const permission = ['YES', 'NO']
    const options = permission.map(perm => ({
      label: capitalize(perm),
      value: perm,
    }))
    return (
      <div style={{marginTop: "34px"}}>
        <BaseDropdown 
          labelFontSize={getFontLabelFontSize(formikProps.values[name])}
          label="Would you like to choose flex for your employees?"
          variant="standard"
          labelStyle={{
            marginLeft: "-10px"
          }}
          fontSize="14"
          // fontSizeInherit
          options={options} 
          formikProps={{...formikProps, name}}
        />
      </div>
    )
  }

  const renderFlexPoints = ({formikProps, name, placeholder, nonEditableField}) => {    
    const options = flexPointUse.map(({display_name, value})=>({
      label: display_name,
      value,
    }))
    return (
      <div style={{marginTop: "34px"}}>
        <BaseDropdown 
          labelFontSize={getFontLabelFontSize(formikProps.values[name])}
          label="Rule for flex points utilisation" 
          variant="standard"
          labelStyle={{
            marginLeft: "-10px"
          }}
          fontSize="14"
          options={options} 
          formikProps={{...formikProps, name}}
        />
      </div>
    )
  }

  const renderFlexDependentEdit = ({formikProps, name, placeholder, nonEditableField}) => {
    const { values, setFieldTouched, handleChange } = formikProps
    const value = values && values[name]
    const permission = ['YES', 'NO']
    const options = permission.map(perm => ({
      label: capitalize(perm),
      value: perm,
    }))
    return (
      <div style={{marginTop: "34px"}}>
        <BaseDropdown 
          labelFontSize={getFontLabelFontSize(formikProps.values[name])}
          label="Allow employees to edit dependent details given by employer?" 
          variant="standard"
          labelStyle={{
            marginLeft: "-10px"
          }}
          fontSize="14"
          options={options} 
          formikProps={{...formikProps, name}}
        />
      </div>
    )
  }
  const renderPermissionToCollectData = ({formikProps, name, placeholder, nonEditableField}) => {
    const { values, setFieldTouched, handleChange } = formikProps
    const value = values && values[name]
    const permission = ['YES', 'NO']
    const options = permission.map(perm => ({
      label: capitalize(perm),
      value: perm,
    }))
    return (
      <div style={{marginTop: "34px"}}>
        <BaseDropdown 
          labelFontSize={getFontLabelFontSize(formikProps.values[name])}
          label="Allow employer to collect employee's data" 
          variant="standard"
          labelStyle={{
            marginLeft: "-10px"
          }}
          fontSize="14"
          options={options} 
          formikProps={{...formikProps, name}}
        />
      </div>
    )
  }
  const renderSourceDropDown = ({formikProps, name, placeholder, nonEditableField}) => {
    const { values, setFieldTouched, handleChange } = formikProps
    const value = values && values[name]
    let field 
    if(name === 'industry'){
      field = industries
    } else {
      field = employeeRange
    }
    return (
      <DropdownComponentWrapper>
        <DropdownWrapper>
          <AgeWrapper
            value={value}
            name={name}
            onChange={handleChange}
            onBlur={(e => setFieldTouched(name, true))}
            color={value && '#009999'}
            fontSize={value && "12px"}
          >
           <Option value='' default disabled selected hidden>
                        {placeholder}
            </Option>
            {field?.map((item, key) => (
              <Option value={item['value']} key={key} >
                {item['display_name']}
              </Option>
            ))}
          </AgeWrapper>
          <Icons style={{ 'position': 'absolute', 'marginLeft': '74%' }} icon='chevron_down' fill="#7e7b7f" />
        </DropdownWrapper>
      </DropdownComponentWrapper>
    )
  }

  const renderForm = (formikProps) => {
    return (
      <HomeWrapper>
        <PageTitle title="Company Information" />
        <div style={{maxWidth: "800px"}}>
        <Form>
          {renderInput({
            name: "company_name",
            placeholder: "Company Name",
            type: "text",
            formikProps,
            nonEditableField : editableField
          })}
          {renderInput({
            name: "city",
            placeholder: "Address",
            type: "text",
            formikProps,
            nonEditableField : editableField
          })}
          {renderInput({
            name: "pincode",
            placeholder: " Pincode",
            type: "number",
            formikProps,
            length: 6,
            nonEditableField : editableField
          })}
          {
            renderSourceDropDown({
              formikProps, name : 'industry', placeholder: "Industry",
              nonEditableField : editableField
            })
          }
          {
            renderSourceDropDown({
              formikProps, name : 'range_of_employees', placeholder: "Range Of Employees",
              nonEditableField : editableField
            })
          }
          {/* {renderInput({
            name: "gstno",
            placeholder: "GST No",
            type: "text",
            formikProps,
            length: 15,
            nonEditableField : editableField
          })} */}

          {renderInputEditable({
            name: "primary_contact_name",
            placeholder: "Primary Contact Name",
            type: "text",
            formikProps,
            nonEditableField : editableField
          })}
           {renderInputNonEditable({
            name: "primary_contact_mobile",
            placeholder: "Primary Contact Mobile",
            type: "number",
            formikProps,
            length: 10,
            nonEditableField : true
          })}
          {renderInputEditable({
            name: "primary_contact_email",
            placeholder: "Primary Contact Email",
            type: "text",
            formikProps,
            nonEditableField : editableField
          })}
          {renderInputEditable({
            name: "secondary_contact_name",
            placeholder: "Secondary Contact Name",
            type: "text",
            formikProps,
            nonEditableField : editableField
          })}
         
          {renderInputEditable({
            name: "secondary_contact_mobile",
            placeholder: "Secondary Contact Mobile",
            type: "number",
            formikProps,
            length: 10,
            nonEditableField : editableField
          })}
          {renderInputEditable({
            name: "secondary_contact_email",
            placeholder: "Secondary Contact Email",
            type: "text",
            formikProps,
            nonEditableField : editableField
          })}
          {/* {
            (flow === 'GMC') && !editableField && renderFlexDropdown({
              formikProps, name : 'flex', placeholder: "Would you like to choose flex for your employees?",
              nonEditableField : editableField
            })
          } */}
          {/* {(
            formikProps &&
            formikProps.values &&
            formikProps.values.flex &&
            formikProps.values.flex === 'YES') &&
            !editableField && renderFlexPoints({
              formikProps, name : 'are_flex_total_points', placeholder: "Are the flex points total points?",
              nonEditableField : editableField
            })
          }
          {(
            formikProps &&
            formikProps.values &&
            formikProps.values.flex &&
            formikProps.values.flex === 'YES') &&
            !editableField && renderFlexDependentEdit({
              formikProps, name : 'edit_dependent_details_allowed', placeholder: "Allow employees to edit dependent details given by employer?",
              nonEditableField : editableField
            })
          }
          {(
            formikProps &&
            formikProps.values &&
            formikProps.values.flex &&
            formikProps.values.flex === 'NO') &&
            (flow === 'GMC') && !editableField && renderPermissionToCollectData({
              formikProps, name : 'employee_collection_required', placeholder: "Allow Employer to Collect Employee Data",
              nonEditableField : editableField
            })
          } */}
          {/* {renderInput({
            name: "source",
            placeholder: "Source",
            type: "text",
            formikProps,
          })} */}

          <ButtonWrapper>
            <LargeButton
              id=""
              textTransform="none"
              label={"Next"}
              type="submit"
            />
          </ButtonWrapper>
        </Form>
        </div>
      </HomeWrapper>
    );
  };
    let Schema 
      Schema = Yup.object().shape({
      company_name: Yup.string().required("*Required"),
      city: Yup.string().required("*Required"),
      pincode: Yup.number().typeError("pincode must be a number").required("*Required").test("len", "pincode must be exactly 6 digits",
        (val) => String(val).length === 6),
      range_of_employees: Yup.string().required("*Required"),
      industry: Yup.string().required("*Required"),
      // gstno: Yup.string().required("*Required"),

      primary_contact_name: Yup.string().matches(/^[a-zA-Z\s.]+$/, 'Name can only contain alphabets and spaces').required("*Required"),
      primary_contact_mobile: Yup.string().matches(/^\d{10}$/, 'Please enter a valid 10-digit phone number').required("*Required"),
      primary_contact_email: Yup.string().email().required("*Required"),

      secondary_contact_name: Yup.string().matches(/^[a-zA-Z\s.]+$/, 'Name can only contain alphabets and spaces').required("*Required"),
      secondary_contact_mobile: Yup.string().matches(/^\d{10}$/, 'Please enter a valid 10-digit phone number').required("*Required"),
      secondary_contact_email: Yup.string().email().required("*Required"),

    });

    return (
    <>
      <SideNav>
        {
          showSidebar() && <SideNavContent />
        }  
      </SideNav>
      {
        loading ? 
        <>
          <LoaderWrapper>
              <LoaderDots /> 
          </LoaderWrapper>
        </> :
        <>
        {/* <WarningPopup
          showPopup={warnings.length > 0}
          onPressOkay={redirectToNextPage}
          messages={warnings}
          heading='Warnings'
        /> */}
        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          validationSchema={Schema}
          onSubmit={handleSubmit}
          render={(formikProps) => renderForm(formikProps)}
        />
        </>
      }
      {
        submitLoader &&
        < OverlayLoader />
      }
        
    </>
    );
  }
// }

const InputContainer = styled.div`
  display: flex;
  position:relative; 
  margin-top: 45px; 
`

const ButtonWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: flex-end;
  margin-top:60px;
`;

const HomeWrapper = styled.div`
  margin-left: 252px;
  transition: margin-left .2s ease-in;
  padding: 50px 80px;
  box-sizing: border-box;
  background:#fff;
`

const LoaderWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-left: 252px;
    height: 100vh;
    align-items:center;
`

const DropdownComponentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 30px;
`;

const AgeWrapper = styled.select`
    display: flex;
    width: 100%;
    border: none;
    font-family: "Inter";
    font-size: ${props => props.fontSize? '1.6rem' : ''};
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.25px;
    color: ${props => props.color ? props.color : "#4a4a4a"};
    background-color: transparent;
    -webkit-appearance: none;
    -moz-appearance: none;
    /* &:hover,
    &:focus 
    {
      outline: 0 !important;
    }; */
    background: none;
    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus {
    transition: background-color 5000s 0s;
    -webkit-text-fill-color: ${props => (props.color ? props.color : '#009999')};
    }
    &::placeholder{
        color: white;
    }
    &:focus {
        outline: none;
        background: none !important;
    }
    &:focus ~ label, &:not(:placeholder-shown) ~ label  {
        top:-200px;
        font-size:14px;
    }
`;

const Option = styled.option`
 color: ${props => props.color ? props.color : 'black'};
 transition:0.3s ease all; 
    -moz-transition:0.3s ease all; 
    -webkit-transition:0.3s ease all;
`

const DropdownWrapper = styled.div`
    display: flex;
    padding: 6px;
    border-bottom: ${props => (props.border ? props.border : '1px solid ' + props.theme.primaryColor)};
    align-items: center;
`;



export default CompanyInfo